import { Collapse } from '@material-ui/core';
import { Translation } from '@ps/web-shared-components';
import React, { useState } from 'react';

// TODO refactor to use composition or shared.scss
// eslint-disable-next-line no-restricted-imports
import { collapse } from '../../../BalanceRecord/BalanceRecord.scss';
import BalanceRecordItem from '../../../BalanceRecordItem/BalanceRecordItem';
import type { Props } from '../../OtherBalances';
// TODO refactor to use composition or shared.scss
// eslint-disable-next-line no-restricted-imports
import { recordTitle, recordTotal } from '../../OtherBalances.scss';

import { TXTCLI_T_Money } from './TournamentMoneyBalances.messages.json';

const TournamentMoneyBalances: React.FC<Props> = ({ balances }) => {
  const [tMoneyExpanded, setTMoneyExpanded] = useState(false);

  return (
    <>
      <div onClick={() => setTMoneyExpanded(!tMoneyExpanded)}>
        <BalanceRecordItem
          className={recordTitle}
          label={<Translation {...TXTCLI_T_Money} />}
          expand={tMoneyExpanded}
          isHeader
        />
      </div>
      <Collapse in={tMoneyExpanded}>
        {balances?.map(({ currency, tMoney }) => (
          <div key={currency} className={collapse}>
            <BalanceRecordItem
              className={recordTotal}
              currency={currency}
              balance={tMoney}
              label={currency}
            />
          </div>
        ))}
      </Collapse>
    </>
  );
};

export default TournamentMoneyBalances;
